import React from 'react';
import { Box, Typography } from '@mui/material';
import { MetalCompositionBrief, MetalValueBrief } from '../types';
import { getQuickMetalStatus } from '../utils/statusHelpers';
import { tokens } from '../theme';

interface MetalStatusBadgeProps {
  metalValues: MetalValueBrief[];
  materialGradeCompositions: MetalCompositionBrief[];
  size?: 'small' | 'medium';
}

function MetalStatusBadge({
  metalValues,
  materialGradeCompositions,
}: MetalStatusBadgeProps): React.ReactElement {
  const { status, label } = getQuickMetalStatus(metalValues, materialGradeCompositions);
  const bad = status === 'error' || status === 'warning';
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 999,
        px: 1,
        py: 0.15,
        bgcolor: bad ? tokens.badSoft : status === 'ok' ? tokens.okSoft : tokens.soft,
        color: bad ? tokens.bad : status === 'ok' ? tokens.ok : tokens.muted,
      }}
    >
      <Typography variant="caption" fontWeight={500} noWrap>
        {label}
      </Typography>
    </Box>
  );
}

export default MetalStatusBadge;
